import React from 'react';
import style from './index.module.css';
import { IconRcAccountSuccess } from '@/assets/account';
type SuccessHeaderProps = {
  text: string;
};

export const SuccessHeader = ({ text }: SuccessHeaderProps) => {
  return (
    <div className={style.container}>
      <IconRcAccountSuccess className={style.successIcon} />
      {text}
    </div>
  );
};
